<template>
  <div class="encounter-actions-wrap">
    <div v-if="showTextBlock" class="encounter-actions-text-block">
      <span class="encounter-actions-title">{{ position.encounter.encounterType.name }}</span>
      <span class="encounter-actions-description">{{ displayDescription }}</span>
    </div>
    <v-card-actions class="justify-center ml-3 rounded transparent battle-actions-row">
      <template v-if="isItemHandoff && !escorted">
        <v-btn
            :loading="isLoading"
            :disabled="!canMove(1)"
            color="escort-btn white--text btn-shadow"
            @click="escortNpc()"
        >
          {{ $t('journey.encounterActions.escortLabel') }} <span><v-icon>mdi-shoe-print</v-icon></span>
        </v-btn>
        <v-btn
            :loading="isLoading"
            color="accent black--text btn-shadow"
            @click="callMeetPokemon()"
        >
          {{ $t('journey.encounterActions.continueLabel') }}
        </v-btn>
      </template>
      <v-btn
          v-else-if="isItemHandoff && escorted"
          :loading="isLoading"
          color="accent black--text btn-shadow"
          @click="callMeetPokemon()"
      >
        {{ $t('journey.encounterActions.continueLabel') }}
      </v-btn>
      <v-btn
          v-else
          :loading="isLoading"
          :disabled="!canMove(1)"
          color="accent black--text btn-shadow"
          @click="backToWild()"
      >
        {{ $t('journey.encounterActions.continueLabel') }} <span><v-icon>mdi-shoe-print</v-icon></span>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {API_ENTRYPOINT} from "@/config/entrypoint";

// ITEM_HANDOFF (Stary dedecek, viz docs/superpowers/specs/
// 2026-09-05-item-handoff-old-grandfather-design.md) je prvni konkretni
// typ encounteru - dve tlacitka (Doprovodit/Obejit), po doprovozeni uz jen
// jedno (Pokracovat). Vsechny ostatni (budouci) typy encounteru padaji do
// puvodniho fallbacku (stejny back-to-wild mechanismus jako
// WildObstacleActions.vue) - jejich vlastni akcni sada prijde s jejich
// vlastnim specem.
//
// BOTTOM varianta textPosition (viz docs/superpowers/specs/
// 2026-09-07-encounter-fullscreen-fe-design.md) - jmeno+text pribehu nad
// tlacitky, jen kdyz encounterType.textPosition === 'BOTTOM'. TOP variantu
// resi EncounterCard.vue.
export default {
  name: "EncounterActions",
  props: {
    position: {type: Object, required: true},
  },
  computed: {
    ...mapGetters({
      isLoading: 'journey/isLoading',
      user: 'user/item',
      steps: 'journey/steps',
    }),
    isItemHandoff() {
      return !!(this.position.encounter && this.position.encounter.encounterType && this.position.encounter.encounterType.template === 'ITEM_HANDOFF');
    },
    escorted() {
      return !!(this.position.encounter && this.position.encounter.data && this.position.encounter.data.escorted === true);
    },
    showTextBlock() {
      return !!(this.position.encounter && this.position.encounter.encounterType && this.position.encounter.encounterType.textPosition === 'BOTTOM');
    },
    // Jakmile je akce encounteru dokoncena (escorted), ukaze se
    // completedDescription (podekovani/potvrzeni odmeny) misto puvodni
    // description - pokud ho encounter typ ma nastaveny, jinak beze zmeny.
    displayDescription() {
      const encounterType = this.position.encounter.encounterType;
      if (this.escorted && encounterType.completedDescription) {
        return encounterType.completedDescription;
      }
      return encounterType.description;
    },
  },
  methods: {
    ...mapActions({
      positionPost: 'journey/positionPost',
      meetPokemon: 'journey/meetPokemon',
      trainerInfoMessages: 'trainer/loadInfoMessages',
    }),
    canMove(steps) {
      return steps <= this.steps;
    },
    escortNpc() {
      const url = new URL("api/encounter-item-handoff", API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id}, method: 'POST'}
      this.positionPost(obj).then(() => {
        this.trainerInfoMessages(this.user.id);
      });
    },
    callMeetPokemon() {
      const obj = {positionId: this.user.position.id, environment: this.position.wild.type, stepCost: 0, actualWildType: this.position.actualWildType};
      this.meetPokemon(obj);
    },
    backToWild() {
      const url = new URL("api/back-to-wild", API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id, stepCost: 1}, method: 'POST'}
      this.positionPost(obj);
    },
  },
}
</script>

<style scoped>
.battle-actions-row {
    flex-wrap: nowrap;
}
.battle-actions-row >>> .v-btn {
    padding: 0 8px;
    min-width: 0;
}
.battle-actions-row >>> .escort-btn {
    background-color: #6D4C41 !important;
}
.encounter-actions-text-block {
  display: flex;
  flex-direction: column;
  padding: 16px 16px 8px;
  background: linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0) 100%);
}
.encounter-actions-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
  margin-bottom: 4px;
}
.encounter-actions-description {
  font-size: 14.5px;
  line-height: 1.5;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
}
</style>
